import React from 'react'
import { FacebookIcon, LinkedinIcon, TwitterIcon } from '../../Icons'
import { useUser } from '../../UserContext';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../reactRoute/RouteConstants';

function Footer() {

  const { userType, setUserType } = useUser();

  const renderLinks = () => {
    if (userType === 'consumer') {
      return (
        <>
          <Link
            to={ROUTES.customerContact}
            className={`font-[600] text-[#475467] cursor-pointer transition-all hover:text-[#F02E49]`}
          >
            Contact
          </Link>
          <span className={`font-[600] text-[#475467] cursor-pointer transition-all hover:text-[#F02E49]`}          >
            Privacy
          </span>
        </>
      );
    } else if (userType === 'dj') {
      return (
        <>
          <Link
            to={ROUTES.djContact}
            className={`font-[600] text-[#475467] cursor-pointer transition-all hover:text-[#F02E49]`}
          >
            Contact
          </Link>
          <span className={`font-[600] text-[#475467] cursor-pointer transition-all hover:text-[#F02E49]`}          >
            Privacy
          </span>
        </>
      );
    }
    return null;
  };

  const renderText = () => {
    if (userType === 'consumer') {
      return (
        <>
          <span className='text-[#475467] text-center'>
            Where Beats Blend into Unforgettable Memories.
          </span>
        </>
      );
    } else if (userType === 'dj') {
      return (
        <>
          <span className='text-[#475467] text-center'>
            Certified DJ - Your Partner in Success. Connecting Talented DJs with Clients in Need.
          </span>
        </>
      );
    }
    return null;
  };

  return (
    <>
      <hr className='mx-[7.7vw]   border-[#eee] max-w-[1600px] w-full' />
      <div className='flex flex-col gap-[64px]  py-[64px] pb-[48px] w-full max-2xl:px-[7.7vw] max-w-[1600px]'>

        <div className="flex items-center w-full justify-start max-sm:flex-col max-sm:justify-center">

          <div className="flex flex-col items-start gap-[32px] max-sm:items-center">
            <div className="flex flex-col gap-[8px] items-start max-sm:items-center">
              <img src="/logo.png" className='w-[170px]' alt="" />
              {renderText()}
            </div>
            <div className="flex items-center gap-[32px]">
              {renderLinks()}
            </div>
          </div>

          {/* <div className="flex flex-col items-center gap-[16px]">

          <span className='font-[500] text-[#F02E49]'>
            Get the app
          </span>

          <img src="/images/appstorebadge.png" alt="" className='w-[135px] cursor-pointer transition-all hover:scale-95' />

          <img src="/images/playstorebadge.png" alt="" className='w-[135px] cursor-pointer transition-all hover:scale-95' />

        </div> */}

        </div>

        <div className="flex items-center justify-center max-sm:gap-[24px] max-sm:flex-col sm:justify-between">
          <span className='text-[#667085] text-center'>
            © 2024 Certified DJ’s. All rights reserved.
          </span>

          <div className="flex items-center gap-[24px]">
            <TwitterIcon iconColor="#98A2B3" className={'cursor-pointer'} />
            <LinkedinIcon iconColor="#98A2B3" className={'cursor-pointer'} />
            <FacebookIcon iconColor="#98A2B3" className={'cursor-pointer'} />
          </div>

        </div>

      </div>
    </>
  )
}

export default Footer